<template>
  <span class="scaling-svg-container">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13.105"
      height="11.794"
      viewBox="0 0 13.105 11.794"
      class="scaling-svg"
    >
      <g transform="translate(-147.448 -355.103)">
        <path
          d="M5.242.655A.655.655,0,0,1,5.9,0,5.9,5.9,0,1,1,0,5.9a.655.655,0,1,1,1.31,0A4.587,4.587,0,1,0,5.9,1.31.655.655,0,0,1,5.242.655Z"
          transform="translate(148.758 355.103)"
        />
        <path
          d="M1.5.192a.655.655,0,0,1,.927,0L3.739,1.5a.655.655,0,0,1-.927.927l-.847-.847-.847.847A.655.655,0,0,1,.192,1.5Z"
          transform="translate(147.448 359.69)"
        />
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class ReturnIcon extends Vue {}
</script>

<style></style>
